import { useSearchParams } from "react-router-dom";
import Login from "./Login";
import { LoginDesignVariant } from "./LoginDesignPanel";
import "./login-design.css";

const options: {key: LoginDesignVariant; label: string; description: string}[] = [
  {key:"radial-suave",label:"Radial suave",description:"O radial original com presença mais discreta."},
  {key:"radial-original",label:"Radial original",description:"A intensidade usada no login anterior."},
  {key:"editorial-verde-escuro",label:"Sem radial",description:"A versão atual, com o fundo verde liso."},
];
const previousOptions: {key: LoginDesignVariant; label: string; description: string}[] = [
  {key:"editorial-discreta", label:"Verde claro", description:"A E3 original, sem os rótulos repetidos de plataforma."},
  {key:"editorial-marfim", label:"Marfim", description:"Um fundo quase branco, levemente quente."},
  {key:"editorial-salvia", label:"Sálvia", description:"Um verde suave, um pouco mais presente."},
  {key:"editorial-areia", label:"Areia", description:"Um neutro quente para acompanhar os verdes da marca."},
  {key:"editorial-e3a",label:"E3A · Leve",description:"Variação tipográfica leve."},
  {key:"editorial-e3b",label:"E3B · Central",description:"Variação centralizada."},
  {key:"editorial-e3c",label:"E3C · Ampla",description:"Variação ampla."},
  {key:"editorial-direta",label:"E1 · Tipográfica",description:"Proposta editorial tipográfica."},
  {key:"editorial-indice",label:"E2 · Índice",description:"Proposta editorial com índice."},
  {key:"editorial",label:"Editorial anterior",description:"Primeira proposta editorial."},
  {key:"essencial",label:"A · Essencial",description:"Primeira proposta essencial."},
  {key:"tecnica",label:"C · Técnica",description:"Primeira proposta técnica."},
  {key:"organica",label:"D · Orgânica",description:"Primeira proposta orgânica."},
  {key:"atual",label:"Atual",description:"O login atual, para comparar."},
];

export default function LoginDesignPreview() {
  const [params,setParams] = useSearchParams();
  const option = [...options,...previousOptions].find(o=>o.key === params.get("opcao")) || options[0];
  return (
    <div className="login-design-preview">
      <header className="login-design-toolbar">
        <div><strong>Login · Textura radial</strong><p>{option.description}</p></div>
        <nav aria-label="Alternativas de login">
          {options.map(o=><button key={o.key} type="button" aria-pressed={o.key===option.key} onClick={()=>setParams({opcao:o.key})}>{o.label}</button>)}
        </nav>
      </header>
      <Login previewVariant={option.key} />
    </div>
  );
}
